<template>
  <section class="slide-7 mb-7.5 px-4.5 flex flex-col items-center">
    <p class="fz-22 mb-12.5" style="line-height: 1.3636;">{{ text.letsTalk }}</p>
    <p class="fz-18 ml-auto w-70 mb-12.5" style="line-height: 1.666666;color: rgba(192, 197, 216, 1)">
      {{ text.weReady }}
    </p>
    <div class="contact-us flex items-center mb-25" @click="toggleContacts">
      <div class="plus relative w-12.5 h-12.5 mr-5 rounded-full" style="background:#ff2e53;" >
        <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
        <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
      </div>
      <p class="uppercase fz-13 font-semibold mr-5" style="line-height: 1;">СВЯЗАТЬСЯ С НАМИ</p>
    </div>
    <footer class="flex flex-col w-full">
      <div class="h-px w-full mb-7.5" style="background:rgba(151, 163, 203, 0.3);"></div>
      <p class="uppercase font-medium fz-10 mb-12.5" style="line-height: 1; color: #6e758d; letter-spacing: 0.3rem" >{{ text.maxFrai }}</p>
      <a href="#mobile-start" class="to-top flex flex-col items-end">
        <svg width="14" height="13" class="transform rotate-180 mb-2.5" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 6L7 12L13 6" stroke="rgba(151, 163, 203, 0.6)" stroke-linejoin="round"/>
          <path d="M6.99998 0V12" stroke="rgba(151, 163, 203, 0.6)" stroke-linejoin="round"/>
        </svg>
        <p class="uppercase font-medium fz-10" style="line-height: 1; color: rgba(151, 163, 203, 0.6); letter-spacing: 0.3rem">{{ text.back }}</p>
      </a>
    </footer>
  </section>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "slide7",
  methods:{
    ...mapMutations(['toggleContacts'])
  },
  computed: {
    text() {
      return require("@/assets/text/reuseable/last/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  }
}
</script>

<style scoped>

</style>
